function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { FrameQuery } from "@custom/schema";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { isTruthy } from "./isTruthy";
import { useLocale } from "./locale";
import { useOperation } from "./operation";
export var useNotificationsStore = create()(persist(function(set) {
    return {
        ignoredNotifications: [],
        path: "",
        unaliasedPath: "",
        overlapWithHero: true,
        setPaths: function(path, unaliasedPath) {
            return set({
                path: path,
                unaliasedPath: unaliasedPath
            });
        },
        dismiss: function(id) {
            return set(function(state) {
                return {
                    ignoredNotifications: _to_consumable_array(state.ignoredNotifications).concat([
                        id
                    ])
                };
            });
        },
        setOverlapWithHero: function(overlapWithHero) {
            return set({
                overlapWithHero: overlapWithHero
            });
        }
    };
}, {
    partialize: function(state) {
        return {
            ignoredNotifications: state.ignoredNotifications
        };
    },
    name: "notifications-store"
}));
export var useNotifications = function() {
    var _data_mediaNotification;
    var locale = useLocale();
    var _useNotificationsStore = useNotificationsStore(), ignoredNotifications = _useNotificationsStore.ignoredNotifications, path = _useNotificationsStore.path, unaliasedPath = _useNotificationsStore.unaliasedPath;
    var data = useOperation(FrameQuery).data;
    var _data_mediaNotification_filter_filter_filter;
    return (_data_mediaNotification_filter_filter_filter = data === null || data === void 0 ? void 0 : (_data_mediaNotification = data.mediaNotification) === null || _data_mediaNotification === void 0 ? void 0 : _data_mediaNotification.filter(isTruthy).filter(function(notification) {
        return notification.locale === locale && !ignoredNotifications.includes(notification.id);
    }).filter(function(notification) {
        var _notification_notificationPaths, _notification_notificationPaths1, _notification_notificationPaths2;
        return ((_notification_notificationPaths = notification.notificationPaths) === null || _notification_notificationPaths === void 0 ? void 0 : _notification_notificationPaths.includes(path.split("/".concat(locale))[1])) || ((_notification_notificationPaths1 = notification.notificationPaths) === null || _notification_notificationPaths1 === void 0 ? void 0 : _notification_notificationPaths1.includes(unaliasedPath)) || ((_notification_notificationPaths2 = notification.notificationPaths) === null || _notification_notificationPaths2 === void 0 ? void 0 : _notification_notificationPaths2.find(function(wildCard) {
            var _path_split_;
            return new RegExp("^".concat(wildCard === null || wildCard === void 0 ? void 0 : wildCard.replace("*", "([^/]+)"), "$")).test((_path_split_ = path.split("/".concat(locale))[1]) === null || _path_split_ === void 0 ? void 0 : _path_split_.replace(/\/$/, ""));
        }));
    })) !== null && _data_mediaNotification_filter_filter_filter !== void 0 ? _data_mediaNotification_filter_filter_filter : [];
};
